import { APPLICATION_TYPE } from "@ca-dmv-radv/data";
import routes, {
  mdlRoutes,
  nchRoutes,
  odpRoutes,
  vdlRoutes,
  rvoRoutes,
  rpcRoutes,
  rvdRoutes,
  rncRoutes,
} from "./routes";

export default function isAuthenticatedRoute() {
  let checkMdl;
  if (window.location.pathname.includes("mdl")) {
    checkMdl = `^/mdl(${mdlRoutes.map(({ path }) => path).join("|")})?/?$`;
  } else if (window.location.pathname.includes("odp")) {
    checkMdl = `^/odp(${odpRoutes.map(({ path }) => path).join("|")})/?$`;
  } else if (window.location.pathname.includes("vdl")) {
    checkMdl = `^/vdl(${vdlRoutes.map(({ path }) => path).join("|")})/?$`;
  } else if (window.location.pathname.includes("nch")) {
    checkMdl = `^/nch(${nchRoutes.map(({ path }) => path).join("|")})/?$`;
  } else if (window.location.pathname.includes("rvd")) {
    checkMdl = `^/rvd(${rvoRoutes.map(({ path }) => path).join("|")})/?$`;
  } else if (window.location.pathname.includes("rvo")) {
    checkMdl = `^/rvo(${rvdRoutes.map(({ path }) => path).join("|")})/?$`;
  } else if (window.location.pathname.includes("rpc")) {
    checkMdl = `^/rpc(${rpcRoutes.map(({ path }) => path).join("|")})/?$`;
  } else if (window.location.pathname.includes("rnc")) {
    checkMdl = `^/rnc(${rncRoutes.map(({ path }) => path).join("|")})/?$`;
  } else {
    checkMdl = `^/dv(${routes.map(({ path }) => path).join("|")})?/?$`;
  }
  const authenticatedRoutesRegex = new RegExp(checkMdl);

  const regExpMatchArray = window.location.pathname.match(
    authenticatedRoutesRegex
  );

  return regExpMatchArray;
}

export const isAuthenticated = (pathname, applicationType) => {
  let determinedRoutes;
  switch (applicationType) {
    case APPLICATION_TYPE.MDL:
      determinedRoutes = mdlRoutes;
      break;
    case APPLICATION_TYPE.ODP:
      determinedRoutes = odpRoutes;
      break;
    case APPLICATION_TYPE.VDL:
      determinedRoutes = vdlRoutes;
      break;
    case APPLICATION_TYPE.NCH:
      determinedRoutes = nchRoutes;
      break;
    case APPLICATION_TYPE.RVD:
      determinedRoutes = rvdRoutes;
      break;
    case APPLICATION_TYPE.RPC:
      determinedRoutes = rpcRoutes;
      break;
    case APPLICATION_TYPE.RVO:
      determinedRoutes = rvoRoutes;
      break;
    case APPLICATION_TYPE.RNC:
      determinedRoutes = rncRoutes;
      break;
    case APPLICATION_TYPE.DV:
    default:
      determinedRoutes = routes;
  }
  return Boolean(
    determinedRoutes.find(({ path }) => path === pathname && path !== "/saved")
  );
};
